import { render, staticRenderFns } from "./sortGoods - 副本.vue?vue&type=template&id=6d9b918f&scoped=true&"
import script from "./sortGoods - 副本.vue?vue&type=script&lang=js&"
export * from "./sortGoods - 副本.vue?vue&type=script&lang=js&"
import style0 from "./sortGoods - 副本.vue?vue&type=style&index=0&id=6d9b918f&prod&langs=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9b918f",
  null
  
)

export default component.exports